import l from "components/util/l";

const areas = [
  l("Administración%SA038"),
  l("Comercio y Bienes de Consumo%SA040"),
  l("Diseño%SA041"),
  l("Educación%SA042"),
  l("Farmacéutica o Biotecnología%SA043"),
  l("Finanzas%SA044"),
  l("Gestión de Proyectos%SA045"),
  l("Gobierno / Sector Público%SA046"),
  l("Industria Automotriz%SA047"),
  l("Ingeniería%SA048"),
  l("Investigación y Desarrollo%SA049"),
  "Legal",
  l("Logística%SA050"),
  l("Manufactura%SA051"),
  "Marketing",
  l("Medios de Comunicación%SA052"),
  l("Recursos Humanos%SA053"),
  l("Relaciones Internacionales%SA054"),
  l("Salud%SA055"),
  l("Servicios%SA056"),
  l("Tecnologías de la Información%SA059"),
  l("Telecomunicaciones%SA060"),
  l("Ventas%SA061"),
  l("Otro%SA062")
];

const positions = {
  "Administración": [
    l("Asistente Administrativo%SA063"),
    l("Coordinador de Recursos Humanos%SA064"),
    l("Director Administrativo%SA065"),
    l("Gerente de Oficina%SA066")
  ],
  "Comercio y Bienes de Consumo": [
    l("Analista de Mercado%SA067"),
    l("Ejecutivo de Ventas%SA068"),
    l("Gerente de Marca%SA069"),
    l("Gerente de Producto%SA070")
  ],
  "Diseño": [
    l("Director de Arte%SA071"),
    l("Diseñador Gráfico%SA072"),
    l("Diseñador UX/UI%SA073"),
    l("Ilustrador%SA074")
  ],
  "Educación": [
    l("Asesor Pedagógico%SA075"),
    l("Coordinador Educativo%SA076"),
    l("Director Académico%SA077"),
    l("Profesor%SA078")
  ],
  "Farmacéutica o Biotecnología": [
    l("Especialista en Regulatorio%SA079"),
    l("Gerente de Producto Farmacéutico%SA080"),
    l("Investigador de Biotecnología%SA081"),
    l("Técnico de Laboratorio%SA082")
  ],
  "Finanzas": [
    l("Analista Financiero%SA083"),
    l("Auditor Interno%SA084"),
    l("Contador%SA085"),
    l("Gerente de Finanzas%SA086")
  ],
  "Gestión de Proyectos": [
    l("Consultor de Gestión de Proyectos%SA087"),
    l("Coordinador de Proyectos%SA088"),
    l("Gerente de Proyectos%SA089"),
    l("Scrum Master%SA090")
  ],
  "Gobierno / Sector Público": [
    l("Asesor Político%SA091"),
    l("Director de Programas Públicos%SA092"),
    l("Funcionario Público%SA093"),
    l("Gestor de Proyectos Sociales%SA094")
  ],
  "Industria Automotriz": [
    l("Diseñador de Vehículos%SA095"),
    l("Ingeniero Automotriz%SA096"),
    l("Jefe de Producción Automotriz%SA097"),
    l("Técnico Automotriz%SA098")
  ],
  "Ingeniería": [
    l("Ingeniero Civil%SA099"),
    l("Ingeniero Eléctrico%SA100"),
    l("Ingeniero Industrial%SA101"),
    l("Ingeniero de Software%SA102")
  ],
  "Investigación y Desarrollo": [
    l("Desarrollador de Productos%SA103"),
    l("Investigador Científico%SA104"),
    l("Investigador de Mercado%SA105"),
    l("Ingeniero de I+D%SA106")
  ],
  "Legal": [
    l("Abogado Corporativo%SA107"),
    l("Abogado Penalista%SA108"),
    l("Asesor Legal%SA109"),
    l("Notario%SA110")
  ],
  "Logística": [
    l("Analista de Cadena de Suministro%SA111"),
    l("Coordinador de Distribución%SA112"),
    l("Gerente de Logística%SA113"),
    l("Supervisor de Almacén%SA114")
  ],
  "Manufactura": [
    l("Ingeniero de Manufactura%SA115"),
    l("Jefe de Planta%SA116"),
    l("Operario de Producción%SA117"),
    l("Supervisor de Producción%SA118")
  ],
  "Marketing": [
    l("Analista de Mercado%SA119"),
    l("Especialista en SEO/SEM%SA120"),
    l("Gerente de Marketing%SA121"),
    l("Social Media Manager%SA122")
  ],
  "Medios de Comunicación": [
    l("Editor de Contenidos%SA123"),
    l("Periodista%SA124"),
    l("Presentador de TV%SA125"),
    l("Productor de Radio%SA126")
  ],
  "Recursos Humanos": [
    l("Consultor en RRHH%SA127"),
    l("Coordinador de Capacitación%SA128"),
    l("Especialista en Reclutamiento%SA129"),
    l("Gerente de Recursos Humanos%SA130")
  ],
  "Relaciones Internacionales": [
    l("Analista de Relaciones Internacionales%SA131"),
    l("Consultor en Política Exterior%SA132"),
    l("Diplomático%SA133"),
    l("Especialista en Comercio Internacional%SA134")
  ],
  "Salud": [
    l("Enfermero/a%SA135"),
    l("Médico General%SA136"),
    l("Psicólogo/a Clínico%SA137"),
    l("Técnico en Radiología%SA138")
  ],
  "Servicios": [
    l("Consultor de Servicios%SA139"),
    l("Coordinador de Servicios Generales%SA140"),
    l("Gerente de Servicios%SA141"),
    l("Supervisor de Atención al Cliente%SA142")
  ],
  "Tecnologías de la Información": [
    l("Administrador de Sistemas%SA143"),
    l("Analista de Seguridad Informática%SA144"),
    l("Desarrollador de Software%SA145"),
    l("Especialista en Big Data%SA146")
  ],
  "Telecomunicaciones": [
    l("Especialista en Comunicaciones%SA147"),
    l("Gerente de Proyectos de Telecomunicaciones%SA148"),
    l("Ingeniero de Telecomunicaciones%SA149"),
    l("Técnico de Redes%SA150")
  ],
  "Ventas": [
    l("Director Comercial%SA151"),
    l("Ejecutivo de Ventas%SA152"),
    l("Gerente de Ventas%SA153"),
    l("Representante de Ventas%SA154")
  ],
  "Otro": [
    "Community Manager",
    l("Consultor Independiente%SA156"),
    l("Emprendedor%SA157"),
    "Freelancer"
  ]
}

export {
  areas, positions
}